export const UPDATE_PROFILE = 'UPDATE_PROFILE'


// WEBPACK FOOTER //
// ./src/constants/User/ProfileEdit.js